/*
 * Copyright 1999-2025 Jagex Ltd.
 */
export const LANG_PLACEHOLDER = '<lang>';
export const LANG_QUERY_NAME = 'lang';
